/**
 * 日历组件需要的工具函数和方法
 */
import { DateTagType, DateShortcutType } from '../components/Calendar/types';
// eslint-disable-next-line import/no-cycle
import { CHECKIN_CHECKOUT_ENUM } from '../res/constants';
import { getHolidays } from '../api/Calendar';
import dayjs from 'dayjs';
import { getNetworkTimeSync } from '@max/meituan-uni-getNetworkTime';
const isMRN = false;
// MRN 使用网络时间 其他使用本机时间
function myNewDate() {
    if (isMRN) {
        return new Date(Number(getNetworkTimeSync().timestamp));
    }
    else {
        return new Date();
    }
}
export function myDayjs() {
    if (isMRN) {
        return dayjs(Number(getNetworkTimeSync().timestamp));
    }
    else {
        return dayjs();
    }
}
const cloneDeep = object => {
    if (!object) {
        return null;
    }
    const result = {};
    const keys = Object.keys(object);
    keys.forEach(key => {
        const target = object[key];
        if (typeof target !== 'object') {
            result[key] = target;
        }
        else {
            if (Array.isArray(target)) {
                const arrayItem = [];
                target.forEach(item => {
                    arrayItem.push(cloneDeep(item));
                });
                result[key] = arrayItem;
            }
            if (typeof target === 'function') {
                return;
            }
            result[key] = cloneDeep(target);
        }
    });
    return result;
};
export const createCalendarItemModel = (day, disabled, shortcutType, isBeforeDawn) => {
    let date;
    let weekday;
    let year;
    let month;
    let value;
    if (day) {
        if (isBeforeDawn) {
            const yesterday = myNewDate();
            yesterday.setTime(yesterday.getTime() - 24 * 60 * 60 * 1000);
            const now = dayjs(yesterday).millisecond(0).second(0).minute(0).hour(0);
            date = now.date();
        }
        else {
            date = day.date();
        }
        year = day.year();
        month = day.month() + 1;
        weekday = day.day();
        value = day.valueOf();
    }
    return {
        value,
        day: date,
        tagType: DateTagType.unset,
        disabled,
        weekday,
        year,
        month,
        shortcutType,
        indexKey: day ? `${year}-${datePadding(month)}-${datePadding(date)}` : ''
    };
};
/**
 * 生成日历组件所需要的前端模型
 * 默认生成6个月内的数据（注意，dayjs拿到的month是索引值，即是正常月份-1）
 */
export const getCalendarModel = (isBeforeDawn) => {
    // 凌晨房获取日期提前一天，为了展示
    const yesterday = myNewDate();
    yesterday.setTime(yesterday.getTime() - 24 * 60 * 60 * 1000);
    const today = dayjs(isBeforeDawn ? yesterday : myNewDate()).millisecond(0).second(0).minute(0).hour(0);
    const todayWeekDay = today.day();
    const days = [{
            month: today.month() + 1,
            year: today.year(),
            values: []
        }];
    // 开始计算的日期
    let startDay = today;
    // 今天不是周日，补齐本周本月内已经过去的日期
    if (todayWeekDay > 0) {
        let i = todayWeekDay; // 初始化时赋值为上周日的日期
        while (i) {
            const day = today.subtract(i, 'days');
            if (day.month() !== today.month()) {
                // 如果已退回到上个月了，则直接跳过不处理c
                i--;
                continue;
            }
            else {
                // 把开始日期设置为过去有效的最早的那天
                if (i === todayWeekDay) {
                    startDay = day;
                }
                days[0].values.push(createCalendarItemModel(day, true, DateShortcutType.unset));
            }
            i--;
        }
    }
    days[0].values.push(createCalendarItemModel(today, false, isBeforeDawn ? DateShortcutType.todayBeforeDawn : DateShortcutType.today, isBeforeDawn));
    // debugger;
    // 最近6个月的时间
    let endDay;
    if (isBeforeDawn) {
        endDay = startDay.add(6, 'month').add(1, 'day');
    }
    else {
        endDay = startDay.add(6, 'month');
    }
    let currentDay = today;
    let currentDayValue = days[0];
    if (isBeforeDawn) {
        currentDay = currentDay.add(1, 'day');
        const month = currentDay.month() + 1;
        const year = currentDay.year();
        if (month !== currentDayValue.month) {
            const valueModel = {
                month,
                year,
                values: []
            };
            days.push(valueModel);
            currentDayValue = valueModel;
        }
        currentDayValue.values.push(createCalendarItemModel(currentDay, false, DateShortcutType.today));
    }
    while (currentDay.diff(endDay)) {
        currentDay = currentDay.add(1, 'day');
        const shortcutType = currentDay.diff(today, 'days') === (isBeforeDawn ? 2 : 1) ? DateShortcutType.tommorrow : DateShortcutType.unset;
        const month = currentDay.month() + 1;
        const year = currentDay.year();
        if (month !== currentDayValue.month) {
            const valueModel = {
                month,
                year,
                values: []
            };
            days.push(valueModel);
            currentDayValue = valueModel;
        }
        const currentModel = createCalendarItemModel(currentDay, false, shortcutType);
        currentDayValue.values.push(currentModel);
    }
    return days;
};
/**
 * 计算日期之间的间隔数
 */
export const calculateDaysInterval = (startDate, endDate) => {
    return dayjs(startDate).diff(dayjs(endDate), 'days');
};
export const datePadding = (num) => {
    if (typeof num === 'number') {
        return num.toString().padStart(2, '0');
    }
    return '';
};
export const getHolidaysModel = calendarModel => {
    // 提取calendarModel里面的月份和年份
    const result = {};
    calendarModel === null || calendarModel === void 0 ? void 0 : calendarModel.forEach(item => {
        const target = result[item.year];
        const { month } = item;
        if (!target) {
            result[item.year] = {
                timeUnit: 1,
                year: item.year,
                months: [month]
            };
        }
        else {
            target.months.push(month);
        }
    });
    return getHolidays({
        query: Object.values(result)
    });
};
// 获取当天的零点，如当前是 2023.10.19 00:40:43，会返回 2023.10.19 00:00:00 对应的时间戳
export const getCurDateYMD = function () {
    let curDate = dayjs(myNewDate());
    return dayjs(`${curDate === null || curDate === void 0 ? void 0 : curDate.year()}-${(curDate === null || curDate === void 0 ? void 0 : curDate.month()) + 1}-${curDate === null || curDate === void 0 ? void 0 : curDate.date()}`).valueOf();
};
export const getDateFilterDesc = (date, calendarData, checkInOutSymbol) => {
    let filterDate = cloneDeep(date);
    const curDateYMDTimeStamp = getCurDateYMD();
    if (calendarData.isBeforeDawn && checkInOutSymbol === CHECKIN_CHECKOUT_ENUM.CHECKIN && (date === null || date === void 0 ? void 0 : date.value) < curDateYMDTimeStamp) {
        filterDate = createCalendarItemModel(dayjs(curDateYMDTimeStamp), false, DateShortcutType.todayBeforeDawn, null);
    }
    return `${datePadding((filterDate === null || filterDate === void 0 ? void 0 : filterDate.month) || 0) || ''}.${datePadding((filterDate === null || filterDate === void 0 ? void 0 : filterDate.day) || '')}`;
};
